import { EventName, Params } from '../types';
import evIdParams from './eventsParams';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

let logger: { log: (arg0: Params) => void };
//@ts-ignore
const Wix = window.Wix;

const reportSendService = (evName: EventName) => {
  logger.log({ ...evIdParams[evName].params });
};

const initLogger = () => {
//@ts-ignore
logger = iframeAppBiLoggerFactory(window.Wix, {
    endpoint: 'wixlabs-users',
  })
    .setEvents({})
    .updateDefaults({
      src: 63,
      app_site_id: (Wix && Wix.Utils.getInstanceId()) || '',
      instance_id: (Wix && Wix.Utils.getOrigCompId()) || '',
      biToken: (Wix && Wix.Utils.getInstanceValue('biToken')) || '',
      hosting: 'wixlabs-users',
    })
    .logger();
};
initLogger();

export default function triggerEvent(evName: EventName) {
  evName && reportSendService(evName);
}
